import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import Login from './Screens/Login';
import Dashboard from './Screens/Dashboard';
import Forget from './Screens/Forget';
import Register from './Screens/Register';
import Invite from './Screens/Invite';
import PasswordUpdate from './Screens/PasswordUpdate';
import Payment from './Screens/Payment';
import Role from './Screens/Role';
import RoleAdd from './Screens/RoleAdd';
import AdminReport from './Screens/AdminReport';
import TenantReport from "./Screens/TenantReport";
import TenantreportView from "./Screens/TenantreportView";
import TenantreportEdit from "./Screens/TenantreportEdit";
import Communication from "./Screens/Communication";
import PaymentView from "./Screens/PaymentView";
import Community from "./Screens/Community";
import CommunityCreate from "./Screens/CommunityCreate";
import CommunityEdit from "./Screens/CommunityEdit";
import CommunityView from "./Screens/CommunityView";
import Designation from "./Screens/Designation";
import Profile from "./Screens/Profile";
import Logo from "./Screens/Logo";
import LogoCreate from "./Screens/LogoCreate";
import DocumentManagement from "./Screens/DocumentManagement";
import PropertyDetails from "./Screens/PropertyDetails";
import PropertyDetailsAdd from "./Screens/PropertyDetailsAdd";
import PropertyDetailsEdit from "./Screens/PropertyDetailsEdit";
import PropertyApproval from "./Screens/PropertyApproval";
import PropertyDetailsView from "./Screens/PropertyDetailsView";
import MaintenanceCharges from "./Screens/Maintenancecharges ";
import MaintenanceDues from "./Screens/Maintenancedues ";
import PaymentChargeTypes from "./Screens/PaymentChargeTypes";
import MaintenanceChargeView from "./Screens/Maintenancechargeview";
import EVoting from "./Screens/EVoting";
import EVotingCreate from "./Screens/EVotingCreate";
import EVotingEdit from "./Screens/EVotingEdit";
import EVotingView from "./Screens/EVotingView";

function App() {
  return (
    <BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Routes>
        <Route path="/" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/forgot" element={<PublicRoute><Forget /></PublicRoute>} />
        <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
        <Route path="/complete-registration" element={<PublicRoute><PasswordUpdate /></PublicRoute>} />
        <Route path="/reset-password" element={<PublicRoute><PasswordUpdate /></PublicRoute>} />
        
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/invite" element={<Invite />} />
          <Route path="/role" element={<Role />} />
          <Route path="/role-add" element={<RoleAdd />} />
          <Route path="/admin-report" element={<AdminReport />} />
          <Route path="/tenant-report" element={<TenantReport />} />
          <Route path="/tenant-report/view/:tenantId" element={<TenantreportView />} />
          <Route path="/tenant-report/edit/:tenantId" element={<TenantreportEdit />} />
          <Route path="/communication" element={<Communication />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/payment-view/:id" element={<PaymentView />} />
          <Route path="/community" element={<Community />} />
          <Route path="/community-create" element={<CommunityCreate />} />
          <Route path="/community-edit/:id" element={<CommunityEdit />} />
          <Route path="/community-view/:id" element={<CommunityView />} />
          <Route path="/designation" element={<Designation />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/logo" element={<Logo />} />
          <Route path="/logo-create" element={<LogoCreate />} />
          <Route path="/document-management" element={<DocumentManagement />} />
          <Route path="/property-details" element={<PropertyDetails />} />
          <Route path="/property-details-add" element={<PropertyDetailsAdd />} />
          <Route path="/property-details-edit/:id" element={<PropertyDetailsEdit />} />
          <Route path="/property-approval" element={<PropertyApproval />} />
          <Route path="/property-details-view/:id" element={<PropertyDetailsView />} />
          <Route path="/maintenance-dues" element={<MaintenanceDues />} />
          <Route path="/maintenance-charges" element={<MaintenanceCharges />} />
          <Route path="/payment-charge-types" element={<PaymentChargeTypes />} />
          <Route path="/maintenance-charges/view/:chargeId" element={<MaintenanceChargeView />} />
          <Route path="/e-voting" element={<EVoting />} />
          <Route path="/e-voting-create" element={<EVotingCreate />} />
          <Route path="/e-voting-edit/:id" element={<EVotingEdit />} />
          <Route path="/e-voting-view/:id" element={<EVotingView />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
